




















import { Component, Vue } from "vue-property-decorator";
import { getRoutePath } from "@/router/routes";

@Component
export default class SystemManagementPopupComponent extends Vue {
  isShow: boolean = false;

  getRoutePath(pageName: string): string {
    return getRoutePath(pageName);
  }

  onClickShow() {
    this.isShow = !this.isShow;
  }

  close() {
    this.isShow = false;
  }
}
